import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceToolsCertificationDialogComponent } from './service-tools-certification-dialog.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

@NgModule({
    declarations: [ServiceToolsCertificationDialogComponent],
    imports: [CommonModule, MatButtonModule, MatIconModule, MatDialogModule],
    exports: [ServiceToolsCertificationDialogComponent],
})
export class ServiceToolsCertificationDialogModule {}
